import { h } from 'preact';
import Scrollable from '../../../../common/hoc/scrollable';
import { useStyles } from '../../../../common/hooks';

function SlidableSlide({ children, style = {}, isFullscreen = false }) {
  const setStyles = useStyles();
  return (
    <Scrollable
      {...({
        ...(!isFullscreen ? setStyles({
          default: { maxHeight: 420 },
          small: { maxHeight: 270 }
        }) : {}),
        ...style
      })
      }
    >
      {children}
    </Scrollable>
  );
}

export default SlidableSlide;
